export default "//static.tradera.net/touchweb/static/output/images/headphones-sneakers.aa886eee.svg";